<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle || scheduleDHeader?.ATTRIB_DESCRIPTION }}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>
<!-- STANDARD Modal Body -->
<div class="modal-body no-body-scroll" [hidden]="minimise">
  <div>
    <form name="screenFrom" id="screenFrom" class="form-horizontal" novalidate>
      <!-- SMALL loader for form content only -->
      @if (showFormLoader) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}
      
      @if (!showFormLoader) {
<div>
        <div class="row">
          <br />
            
            <!-- Entity Information Display (if not exam scenario) -->
            @if (!isExamScenario) {
<div style="padding-bottom: 0 !important;">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-6">
                    <div class="col-md-1">
                      <span class="LayerLine1">Entity:</span>
                    </div>
                    <div class="col-md-10">
                      <span class="LayerData1">{{ rowData.LEID + " " + ":" + " " + rowData.LE_NAME + " " + ":" + " " + rowData.TAX_YEAR_BEGIN + " " + "-" + " " + rowData.TAX_YEAR_END }}</span>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="col-md-2">
                      <span class="LayerLine1">Business:</span>
                    </div>
                    <div class="col-md-9">
                      <span class="LayerData1">{{ rowData.ME_CODE + " " + "-" + " " + rowData.ME_NAME }}</span>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="col-md-6">
                      <span class="LayerLine1">Tax Code:</span>
                    </div>
                    <div class="col-md-6">
                      <span class="LayerData1">{{ rowData.CDR_NO }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
}

            <!-- Entity Information Display (if exam scenario) -->
            @if (isExamScenario) {
<div style="padding-bottom: 0 !important;">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-4">
                    <div class="col-md-2">
                      <span class="LayerLine1">Entity:</span>
                    </div>
                    <div class="col-md-10">
                      <span class="LayerData1">{{ rowData.LEID + " " + ":" + " " + rowData.LE_NAME + " " + ":" + " " + rowData.TAX_YEAR_BEGIN + " " + "-" + " " + rowData.TAX_YEAR_END }}</span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="col-md-3">
                      <span class="LayerLine1">Business:</span>
                    </div>
                    <div class="col-md-9">
                      <span class="LayerData1">{{ rowData.ME_CODE + " " + "-" + " " + rowData.ME_NAME }}</span>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="col-md-6">
                      <span class="LayerLine1">Tax Code:</span>
                    </div>
                    <div class="col-md-6">
                      <span class="LayerData1">{{ rowData.CDR_NO }}</span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <span class="LayerLine1" [attr.global-issue-id]="globalService?.globalParams?.issue_id || ''"></span>
                  </div>
                </div>
              </div>
            </div>
}

            <!-- Form Title Table -->
            <table class="InnerTblBG" style="width: 100%; border : 0px; font-weight: bold;">
              <tbody>
                <tr>
                  <th class="BlackSmHdrBC">
                    <h4>{{ scheduleDHeader?.ATTRIB_DESCRIPTION }} <span style="color: red;">(Inc/Dec)</span></h4>
                  </th>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                </tr>
              </tbody>
            </table>

            <!-- Info Table -->
            <table class="InnerTblBG" style="width: 100%; border : 0px;">
              <tbody>
                <tr>
                  <td style="width: 5px;">
                    <i class="fa fa-info-circle" style="font-size:24px;color:skyblue"></i>
                  </td>
                  <td class="BlackTxtBL">
                    {{ scheduleDHeader?.ATTRIB_DESCRIPTION }} (Increase/Decrease Format)
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Main Form Table -->
            <table class="table table-bordered form-inline InnerTblBG">
              @for (row of scheduleDFormData; track $index; let mainIndex = $index) {
<tr class="row">
                
                <!-- TH Row Type -->
                @if (row.ROW_TYPE==='TH') {

                  @for (item of row.Line_data; track $index) {
<td
                      class="row"
                      style="font-weight: bold;"
                      [attr.align]="item.COL_CLASS"
                      [attr.colspan]="item.COLSPAN"
                      [ngClass]="{'color-red' : item.ATTRIB_VALUE < 0 }">
                    @if (item.DESCRIPTION==='Unallocated Amount' && unAllocatedAmt !== 0) {
<p style="color:red;">
                      {{ numberWithCommas(item.ATTRIB_VALUE) }}
                    </p>
}
                    @if (item.DESCRIPTION==='Unallocated Amount' && unAllocatedAmt === 0) {
<p style="color:green;">
                      {{ numberWithCommas(item.ATTRIB_VALUE) }}
                    </p>
}
                    @if (item.DESCRIPTION!=='Unallocated Amount') {
<p>
                      {{ numberWithCommas(item.ATTRIB_VALUE) }}
                    </p>
}
                  </td>
}
                
}

                <!-- PH Row Type -->
                @if (row.ROW_TYPE==='PH') {
<td style="font-weight: bold;" class="row" colspan="12">
                  {{ row.Line_data[0]?.ATTRIB_VALUE }}
                </td>
}

                <!-- DT Row Type -->
                @if (row.ROW_TYPE==='DT') {

                  @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td
                      class="row"
                      [attr.colspan]="item.COLSPAN">
                    @if (item.EDIT_TYPE==='currency' && item.DATA_TYPE==='number') {
<p>
                      <input [(ngModel)]="item.ATTRIB_VALUE" 
                             [name]="'dt_currency_' + mainIndex + '_' + itemIndex"
                             class="form-control input-md numText"
                             type="text"
                             onlyIntegersWithLength
                             (blur)="updateAmount(itemIndex, item.LINE_NO)"
                             (ngModelChange)="valuechanged(mainIndex, item.OCCURRENCE, item.LINE_NO, itemIndex, item.ROW_TYPE)"
                             [disabled]="item.IS_EDITABLE==='N'">
                    </p>
}
                    @if (item.EDIT_TYPE==='label' && item.DATA_TYPE==='string') {
<p>
                      {{ item.ATTRIB_VALUE }}
                    </p>
}
                  </td>
}
                
}

                <!-- CH Row Type (Complex nested table) -->
                @if (row.ROW_TYPE==='CH') {
<td colspan="12">
                  <table class="table table-bordered form-inline InnerTblBG">
                    @for (item of row.Line_data; track $index; let itemIndex = $index) {
<tr class="row">
                      
                      <!-- HEADER_ROW -->
                      @if (item.Line_Type==='HEADER_ROW') {

                        @for (column of item.Line_data_occ.slice(0, item.Line_data_occ.length-2); track $index) {
<th class="row">
                          @if (column.ATTRIB_DESCRIPTION != 'Comments') {
<p>
                            {{ column.ATTRIB_VALUE }}
                          </p>
}
                        </th>
}
                      
}

                      <!-- SUB_ROW -->
                      @if (item.Line_Type==='SUB_ROW') {
<td class="row">
                        <div class="row-actions row-actions--between">
                          <span>{{ item.Line_no }}</span>
                          <i class="fa fa-plus-circle color-green fa-lg"
                             title="Add Details"
                             (click)="AddNewRow(item.Line_no)">
                          </i>
                        </div>
                      </td>
}
                      @if (item.Line_Type==='SUB_ROW') {
<td class="row" colspan="13">
                        Add Details
                      </td>
}

                      <!-- DATA_ROW -->
                      @if (item.Line_Type==='DATA_ROW' && item.Is_Multi==='Y') {
<td class="row">
                        <div class="row-actions">
                          @if (item.IS_EDITABLE==='Y') {
<i class="fa fa-pencil bluepencil"
                            
                             title="Edit Details"
                             (click)="editExistingRecord(item.Line_no, item.Occurrence, itemIndex)">
                          </i>
}
                          @if (item.IS_EDITABLE==='Y') {
<i class="fa fa-minus-circle color-red fa-lg"
                            
                             title="Remove Details"
                             (click)="removeExistingRecord(item.Line_no, item.Occurrence, itemIndex)">
                          </i>
}
                        </div>
                      </td>
}
                      @if (item.Line_Type==='DATA_ROW' && item.Is_Multi==='Y') {

                        @for (column of item.Line_data_occ.slice(1, item.Line_data_occ.length-2); track $index; let colIndex = $index) {
<td class="row">
                        @if (column.ATTRIB_DESCRIPTION != 'Comments' && column.ATTRIB_DESCRIPTION != 'Loss Transaction?' && column.DATA_TYPE == 'number') {
<p
                           [ngClass]="{'color-red' : column.ATTRIB_VALUE < 0 }">
                          {{ numberWithCommas(column.ATTRIB_VALUE) }}
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                            {{ column.ATTRIB_VALUE_ERROR }}
                          </span>
}
                        </p>
}
                        @if (column.ATTRIB_DESCRIPTION != 'Comments' && column.ATTRIB_DESCRIPTION != 'Loss Transaction?' && column.DATA_TYPE != 'number' && column.ATTRIB_DESCRIPTION === 'Category Code') {
<p>
                          {{ categoryCode[column.ATTRIB_VALUE] }}
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                            {{ column.ATTRIB_VALUE_ERROR }}
                          </span>
}
                        </p>
}
                        @if (column.ATTRIB_DESCRIPTION != 'Comments' && column.ATTRIB_DESCRIPTION != 'Loss Transaction?' && column.DATA_TYPE != 'number' && column.ATTRIB_DESCRIPTION !== 'Category Code') {
<p>
                          {{ column.ATTRIB_VALUE }}
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                            {{ column.ATTRIB_VALUE_ERROR }}
                          </span>
}
                        </p>
}
                        @if (column.ATTRIB_DESCRIPTION == 'Loss Transaction?' && column.ATTRIB_VALUE == 'N') {
<p>
                          {{ column.ATTRIB_VALUE }}
                        </p>
}
                        @if (column.ATTRIB_DESCRIPTION == 'Loss Transaction?' && (column.ATTRIB_VALUE == 'Y' || column.ATTRIB_VALUE == 'YES')) {
<p>
                          {{ column.ATTRIB_VALUE }}
                          <button type="button"
                                  style="border: none; padding: 0; background: none; color: Blue;"
                                  (click)="lossTransaction(column.ATTRIB_SHORT_CODE, mainIndex, itemIndex, column.ATTRIB_VALUE, column.OCCURRENCE)">
                            (View/Edit)
                          </button>
                        </p>
}
                        </td>
}
                      
}

                      <!-- DATA_COMMENTS -->
                      @if (item.Line_Type==='DATA_COMMENTS' && item.Is_Multi==='Y') {
<td
                          class="row"
                          style="text-align: left !important" colspan="2">
                        <h4 style="font-weight: bold;">{{ item.Line_data_occ[0]?.ATTRIB_DESCRIPTION }}:</h4>
                      </td>
}
                      @if (item.Line_Type==='DATA_COMMENTS' && item.Is_Multi==='Y') {
<td class="row" colspan="12">
                        {{ item.Line_data_occ[0]?.ATTRIB_VALUE }}
                      </td>
}

                      <!-- NEW_EDIT_ROW -->
                      @if (item.Line_Type==='NEW_EDIT_ROW' && item.Is_Multi==='Y') {
<td class="row">
                        <div class="row-actions">
                          <i class="fa fa-check-circle color-green fa-lg"
                             title="Save Details"
                             (click)="saveNewEdittedRecord(item.Line_no, item.Occurrence, itemIndex)">
                          </i>
                          <i class="fa fa-minus-circle color-red fa-lg"
                             title="Remove Details"
                             (click)="removeExistingRecord(item.Line_no, item.Occurrence, itemIndex)">
                          </i>
                        </div>
                      </td>
}
                      @if (item.Line_Type==='NEW_EDIT_ROW' && item.Is_Multi==='Y') {

                        @for (column of item.Line_data_occ.slice(1, item.Line_data_occ.length-2); track $index; let colIndex = $index) {
<td class="row">
                        
                        <!-- Label -->
                        @if (column.EDIT_TYPE==='label' && column.DATA_TYPE==='number') {
<p>
                          {{ column.ATTRIB_VALUE }}
                        </p>
}

                        <!-- Radio buttons (Perm/Temp) -->
                        @if (column.EDIT_TYPE==='radio' && column.DATA_TYPE==='string') {
<p class="radio-stack">
                          <label class="radio-stack__item">
                            <input type="radio"
                                   [name]="'radio_' + mainIndex + '_' + itemIndex + '_' + colIndex"
                                   value="Perm"
                                   [checked]="column.ATTRIB_VALUE === 'Perm'"
                                   (change)="column.ATTRIB_VALUE = 'Perm'; valuechanged(mainIndex, column.OCCURRENCE, column.LINE_NO, colIndex, column.ROW_TYPE)">
                            <span>Perm</span>
                          </label>
                          <label class="radio-stack__item">
                            <input type="radio"
                                   [name]="'radio_' + mainIndex + '_' + itemIndex + '_' + colIndex"
                                   value="Temp"
                                   [checked]="column.ATTRIB_VALUE === 'Temp'"
                                   (change)="column.ATTRIB_VALUE = 'Temp'; valuechanged(mainIndex, column.OCCURRENCE, column.LINE_NO, colIndex, column.ROW_TYPE)">
                            <span>Temp</span>
                          </label>
                        </p>
}

                        <!-- Textarea -->
                        @if (column.EDIT_TYPE==='text' && column.DATA_TYPE==='string') {
<p>
                          <textarea style="width: 100%" 
                                    class="form-control input-sm numText"
                                    [value]="column.ATTRIB_VALUE || ''"
                                    (input)="column.ATTRIB_VALUE = $any($event.target).value; valuechanged(mainIndex, column.OCCURRENCE, column.LINE_NO, colIndex, column.ROW_TYPE)"
                                    placeholder="<-- Enter Details here -->">
                          </textarea>
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                            {{ column.ATTRIB_VALUE_ERROR }}
                          </span>
}
                        </p>
}

                        <!-- Currency input -->
                        @if (column.EDIT_TYPE==='currency' && column.DATA_TYPE==='number') {
<p>
                          <input style="text-align: right; width:90px"
                                 [(ngModel)]="column.ATTRIB_VALUE"
                                 [name]="'edit_currency_' + mainIndex + '_' + itemIndex + '_' + colIndex"
                                 onlyIntegersWithLength
                                 class="form-control input-md numText"
                                 type="text"
                                 (ngModelChange)="valuechanged(mainIndex, column.OCCURRENCE, column.LINE_NO, colIndex, column.ROW_TYPE)"
                                 (blur)="updateAmount(itemIndex, column.LINE_NO)">
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                            {{ column.ATTRIB_VALUE_ERROR }}
                          </span>
}
                        </p>
}

                        <!-- Checkbox -->
                        @if (column.EDIT_TYPE==='checkbox' && column.DATA_TYPE==='string') {
<p>
                          <input type="checkbox"
                                 [checked]="column.ATTRIB_VALUE === 'Y'"
                                 (change)="onCheckboxChange($event, column, mainIndex, colIndex, itemIndex)">
                        </p>
}

                        <!-- Date picker (custom date various) -->
                        @if (column.EDIT_TYPE==='custom_date_various' && column.DATA_TYPE==='dateVarious') {
<div class="form-inline" style="white-space: nowrap; min-width: 150px;">
                          <div class="form-group" style="margin: 0">
                            <input type="checkbox" 
                                   [checked]="column.ATTRIB_VALUE === 'VARIOUS'" 
                                   (change)="onDateVariousCheckboxChange(column, mainIndex, column.OCCURRENCE, column.LINE_NO, colIndex, column.ROW_TYPE, $event)"
                                   title="Various"
                                   style="margin-right: 5px;">
                          </div>
                          <div class="form-group" style="margin: 0">
                            @if (column.ATTRIB_VALUE !== 'VARIOUS') {
<input 
                                   type="date" 
                                   class="form-control"
                                   [value]="getDateValueForInput(column.ATTRIB_VALUE)"
                                   (change)="column.ATTRIB_VALUE = $any($event.target).value; valuechanged(mainIndex, column.OCCURRENCE, column.LINE_NO, colIndex, column.ROW_TYPE)"
                                   style="min-width: 150px;">
}
                            @if (column.ATTRIB_VALUE === 'VARIOUS') {
<input 
                                   type="text" 
                                   class="form-control" 
                                   value="VARIOUS" 
                                   disabled
                                   style="min-width: 150px;">
}
                          </div>
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                            {{ column.ATTRIB_VALUE_ERROR }}
                          </span>
}
                        </div>
}

                        <!-- Select (Code from Instructions) -->
                        @if (column.EDIT_TYPE === 'select' && column.DATA_TYPE === 'string' && column.ATTRIB_DESCRIPTION === 'Code from Instructions') {
<p>
                          <select [(ngModel)]="column.ATTRIB_VALUE"
                                  [name]="'code_instr_' + mainIndex + '_' + itemIndex + '_' + colIndex"
                                  class="form-control"
                                  (ngModelChange)="valuechanged(mainIndex, column.OCCURRENCE, column.LINE_NO, colIndex, column.ROW_TYPE)">
                            <option value=""></option>
                            @for (code of codeAdj; track $index) {
<option [value]="code">{{ code }}</option>
}
                          </select>
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                            {{ column.ATTRIB_VALUE_ERROR }}
                          </span>
}
                        </p>
}

                        <!-- Select (Checkbox on 8949) -->
                        @if (column.EDIT_TYPE === 'select' && column.DATA_TYPE === 'string' && column.ATTRIB_DESCRIPTION === 'Checkbox on 8949') {
<p>
                          <select [(ngModel)]="column.ATTRIB_VALUE"
                                  [name]="'chk8949_' + mainIndex + '_' + itemIndex + '_' + colIndex"
                                  class="form-control"
                                  (ngModelChange)="valuechanged(mainIndex, column.OCCURRENCE, column.LINE_NO, colIndex, column.ROW_TYPE)">
                            <option value=""></option>
                            @for (opt of getCheckbox8949Options(item.Line_no); track $index) {
<option [value]="opt">{{ opt }}</option>
}
                          </select>
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                            {{ column.ATTRIB_VALUE_ERROR }}
                          </span>
}
                        </p>
}

                        <!-- Dropdown (Category Code) -->
                        @if (column.EDIT_TYPE === 'dropdown' && column.DATA_TYPE === 'string' && column.ATTRIB_DESCRIPTION === 'Category Code') {
<p>
                          <select [(ngModel)]="column.ATTRIB_VALUE"
                                  [name]="'cat_code_' + mainIndex + '_' + itemIndex + '_' + colIndex"
                                  class="form-control"
                                  (ngModelChange)="valuechanged(mainIndex, column.OCCURRENCE, column.LINE_NO, colIndex, column.ROW_TYPE)">
                            <option value=""></option>
                            @for (key of getCategoryCodeKeys(); track $index) {
<option [value]="key">
                              {{ categoryCode[key] }}
                            </option>
}
                          </select>
                          @if (column.HAS_ERROR==='Y') {
<span class="form-error-container">
                            {{ column.ATTRIB_VALUE_ERROR }}
                          </span>
}
                        </p>
}
                        </td>
}
                      
}

                      <!-- NEW_EDIT_COMMENT_ROW -->
                      @if (item.Line_Type==='NEW_EDIT_COMMENT_ROW' && item.Is_Multi==='Y') {
<td
                          class="row"
                          style="text-align: left !important" colspan="2">
                        <h4 style="font-weight: bold;">{{ item.Line_data_occ[0]?.ATTRIB_DESCRIPTION }}:</h4>
                      </td>
}
                      @if (item.Line_Type==='NEW_EDIT_COMMENT_ROW' && item.Is_Multi==='Y') {
<td class="row" colspan="12">
                        <textarea style="width: 100%" 
                                  class="form-control input-sm"
                                  [(ngModel)]="item.Line_data_occ[0].ATTRIB_VALUE"
                                  [name]="'comment_' + mainIndex + '_' + itemIndex"
                                  placeholder="<--- Enter Comments here --->"
                                  (ngModelChange)="valuechanged(itemIndex, item.Line_data_occ[0].OCCURRENCE, item.Line_data_occ[0].LINE_NO, 0, item.Line_data_occ[0].ROW_TYPE)">
                        </textarea>
                      </td>
}
                    </tr>
}
                  </table>
                </td>
}
              </tr>
}
            </table>
        </div>
      </div>
}
    </form>
  </div>
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise" style="padding-top: 0 !important;">
  @if (currentTabName != 'Subsidiary') {
<button
          class="save-button"
          type="button"
          [disabled]="isSaveClicked || !isValidScenario || isLocked"
          [title]="isLocked ? 'Screen is locked — save disabled' : ''"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
}
  @if (currentTabName != 'Subsidiary') {
<button 
          class="reset-button" 
          type="button" 
          (click)="reset()">Reset</button>
}
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
